<template>
  <div class="field-multiselect" v-click-outside="closeMenu">
    <button
      type="button"
      class="form-control text-left d-flex justify-content-between align-items-center"
      :disabled="disabled"
      @click="menuOpen = !menuOpen"
    >
      <span class="text-truncate flex-grow-1 mr-2">{{ buttonLabel }}</span>
      <span class="flex-shrink-0 small" aria-hidden="true">{{ menuOpen ? '▲' : '▼' }}</span>
    </button>
    <div v-if="menuOpen" ref="panel" :class="['field-multiselect-panel border rounded bg-white shadow-sm', flipped ? 'flip-up' : 'mt-1']">
      <label
        v-for="opt in checkboxOptions"
        :key="opt.value"
        class="d-flex align-items-center px-2 py-1 mb-0 field-multiselect-item"
      >
        <input
          type="checkbox"
          :value="opt.value"
          :checked="isChecked(opt.value)"
          :disabled="disabled"
          class="mr-2"
          @change="toggleOption(opt.value, $event)"
        />
        <span>{{ opt.text }}</span>
      </label>
    </div>
    <ul v-if="selectedLabels.length" class="list-unstyled mb-0 mt-1">
      <li v-for="label in selectedLabels" :key="label" class="text-muted small">• {{ label }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'field-multiselect',
  directives: {
    'click-outside': {
      bind: function (el, binding) {
        el._clickOutside = function (e) {
          if (!el.contains(e.target)) {
            binding.value();
          }
        };
        document.addEventListener('click', el._clickOutside);
      },
      unbind: function (el) {
        document.removeEventListener('click', el._clickOutside);
      }
    }
  },
  props: {
    options: {
      default: function () { return []; }
    },
    value: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      menuOpen: false,
      flipped: false,
      localSelection: []
    };
  },
  computed: {
    checkboxOptions: function () {
      if (!_.isArray(this.options)) {
        return [];
      }
      return this.options.map(function (o) {
        return {
          value: o.value != null ? String(o.value) : o.value,
          text: o.name || o.text || String(o.value)
        };
      });
    },
    buttonLabel: function () {
      var s = this.localSelection;
      if (!s.length) {
        return 'Selecione…';
      }
      if (s.length <= 0) {
        var self = this;
        return s.map(function (v) {
          var o = _.find(self.checkboxOptions, function (x) { return String(x.value) === String(v); });
          return o ? o.text : v;
        }).join(', ');
      }
      return s.length + ' selecionados';
    },
    selectedLabels: function () {
      var self = this;
      return this.localSelection.map(function (v) {
        var o = _.find(self.checkboxOptions, function (x) { return String(x.value) === String(v); });
        return o ? o.text : v;
      });
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val) {
        this.localSelection = this.normalizeSelection(val);
      }
    },
    menuOpen: function (open) {
      if (open) {
        this.flipped = false;
        var self = this;
        this.$nextTick(function () {
          var panel = self.$refs.panel;
          if (!panel) return;
          var rect = panel.getBoundingClientRect();
          if (rect.bottom > window.innerHeight) {
            self.flipped = true;
          }
        });
      }
    }
  },
  methods: {
    normalizeSelection: function (val) {
      if (val == null || val === '') {
        return [];
      }
      if (!_.isArray(val)) {
        return [String(val)];
      }
      return val.map(function (v) { return String(v); });
    },
    isChecked: function (value) {
      return this.localSelection.indexOf(String(value)) !== -1;
    },
    toggleOption: function (value, event) {
      var strVal = String(value);
      var idx = this.localSelection.indexOf(strVal);
      var next = this.localSelection.slice();
      if (idx !== -1) {
        next.splice(idx, 1);
      } else {
        next.push(strVal);
      }
      this.localSelection = next;
      this.$emit('change', next);
      this.$emit('input', next);
    },
    closeMenu: function () {
      this.menuOpen = false;
    }
  }
};
</script>

<style scoped>
.field-multiselect {
  position: relative;
}
.field-multiselect-panel {
  position: absolute;
  z-index: 1050;
  width: 100%;
  max-height: 280px;
  overflow-y: auto;
}
.field-multiselect-panel.flip-up {
  bottom: 100%;
  top: auto;
  margin-bottom: 4px;
}
.field-multiselect-item:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}
</style>
